import { render, staticRenderFns } from "./GruposSettings.vue?vue&type=template&id=6bb70870"
import script from "./GruposSettings.vue?vue&type=script&lang=js"
export * from "./GruposSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports